export default "__VITE_ASSET__Ce4p$AcP__"